<template>
  <a-select v-model="currentValue" allowClear>

      <a-select-opt-group
        v-for="group in options"
        :key="group.id"
        :title="group.name"
      >
        <a-select-option
          v-for="item in group.categories"
          :key="item.id"
          :title="item.name"
         >
          {{ item.name }}
        </a-select-option>
      </a-select-opt-group>
  </a-select>
</template>
<script>
import { _getCategoryBySeries } from '@/api/goodsCategoryApi';

export default {
  name: 'GoodsCategorySelect',
  props: {
    dictCode: String,
    value: String,
  },
  data() {
    return {
      form: {
        visible: false,
        data: {
          name: '',
        },
      },
      table: {
        data: [],
      },
      options: [],
      currentValue: this.value,
      currentGoodsName: '',
    };
  },
  watch: {
    currentValue(val) {
      this.$emit('input', val);
    },
    value(val) {
      this.currentValue = val;
    },
  },
  methods: {
  },
  async created() {
    const result = await _getCategoryBySeries();
    this.options = result;
  },
};
</script>

<style scoped>
  .goods-wrap {
    height: 400px;
    overflow-y: auto;
  }

  .goods-item {
    margin: 10px 5px;
    cursor: pointer;
  }

  .goods-item:hover {
    color: #00A8CC;
  }

</style>
